import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexCompanyTransferRequests from "./transfers/companyTransfers/IndexCompanyTransferRequests";
import IndexTransferApprovals from "./transfers/transferApproval/IndexTransferApprovals";
import IndexSubordinateTransferRequests from "./transfers/subordinateTransfers/IndexSubordinateTransferRequests";
import IndexCompanyPromotionRequests from "./promotions/companyPromotions/IndexCompanyPromotionRequests";
import IndexPromotionApprovals from "./promotions/promotionApproval/IndexPromotionApprovals";
import IndexSubordinatePromotionRequests from "./promotions/subordinatePromotions/IndexSubordinatePromotionRequests";
import IndexTranferConfigurations from "./transfers/settings/configuration/IndexTransferConfigurations";
import { guardElement } from "@comps/components";



const TransferPromotionModules = () => {
  return (
    <Routes>
      <Route path="transfers/company-requests" element={ guardElement(<IndexCompanyTransferRequests modkey="companyTransfers"/>, "companyTransfers") } />
      <Route path="transfers/subordinate-requests" element={ guardElement(<IndexSubordinateTransferRequests modkey="subordinateTransfers"/>, "subordinateTransfers") } />
      <Route path="transfers/approvals" element={ guardElement(<IndexTransferApprovals api="transferApprovals" modkey="transferApprovals"/>, "transferApprovals") } />
      <Route path="transfers/delegates" element={ guardElement(<IndexTransferApprovals api="transferDelegates" modkey="transferDelegates"/>, "transferDelegates") } />
      <Route path="promotions/company-requests" element={ guardElement(<IndexCompanyPromotionRequests modkey="companyPromotions"/>, "companyPromotions") } />
      <Route path="promotions/subordinate-requests" element={ guardElement(<IndexSubordinatePromotionRequests modkey="subordinatePromotions"/>, "subordinatePromotions") } />
      <Route path="promotions/approvals" element={ guardElement(<IndexPromotionApprovals api="promotionApprovals" modkey="promotionApprovals"/>, "promotionApprovals") } />
      <Route path="promotions/delegates" element={ guardElement(<IndexPromotionApprovals api="promotionDelegates" modkey="promotionDelegates"/>, "promotionDelegates") } />
      <Route path="settings/configurations" element={ guardElement(<IndexTranferConfigurations api="transferConfigurations" modkey="transferConfigurations"/>, "transferConfigurations") } />
    </Routes>
  );
}

export default TransferPromotionModules;
